export enum PricingCardType {
	PerStay = 1,
	PerNight = 2,
	Fixed = 3,
}
